import { render, staticRenderFns } from "./contactus.vue?vue&type=template&id=c6bbfd1a&scoped=true&"
import script from "./contactus.vue?vue&type=script&lang=js&"
export * from "./contactus.vue?vue&type=script&lang=js&"
import style0 from "./contactus.vue?vue&type=style&index=0&id=c6bbfd1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bbfd1a",
  null
  
)

export default component.exports